import _classCallCheck from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Component, PropTypes } from 'react';
import styles from '../../../build/styles';
import { getCallbacks } from '../../helper/helper';

var Modal =
/*#__PURE__*/
function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    _classCallCheck(this, Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Modal).apply(this, arguments));
  }

  _createClass(Modal, [{
    key: "createModalClassName",
    value: function createModalClassName() {
      return [styles.modal, this.props.isActive ? styles.isActive : '', this.props.className].join(' ').trim();
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      if (this.props.type === 'image') {
        return React.createElement('div', _extends({
          className: styles.modalContent
        }, getCallbacks(this.props)), this.props.children);
      }

      if (this.props.type === 'card') {
        return React.createElement('div', {
          className: [styles.modalCard, '__re-bulma_modal_card'].join(' ')
        }, React.createElement('header', {
          className: styles.modalCardHead
        }, React.createElement('p', {
          className: styles.modalCardTitle
        }, this.props.headerContent), React.createElement('button', {
          className: styles.delete,
          onClick: this.props.onCloseRequest
        })), React.createElement('section', {
          className: styles.modalCardBody
        }, this.props.children), this.props.footerContent ? React.createElement('footer', {
          className: styles.modalCardFoot
        }, this.props.footerContent) : null);
      }

      return React.createElement('div', {
        className: styles.modalContainer
      }, React.createElement('div', _extends({
        className: styles.modalContent
      }, getCallbacks(this.props)), this.props.children));
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement('div', {
        className: this.createModalClassName()
      }, React.createElement('div', {
        className: styles.modalBackground,
        onClick: this.props.onCloseRequest
      }), this.renderContent(), this.props.showOverlayCloseButton ? React.createElement('button', {
        className: styles.modalClose,
        onClick: this.props.onCloseRequest
      }) : null);
    }
  }]);

  return Modal;
}(Component);

export { Modal as default };
Modal.propTypes = {
  style: PropTypes.object,
  children: PropTypes.any,
  className: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  onCloseRequest: PropTypes.func,
  showOverlayCloseButton: PropTypes.bool,
  headerContent: PropTypes.node,
  footerContent: PropTypes.node,
  type: PropTypes.oneOf(['card', 'image'])
};
Modal.defaultProps = {
  style: {},
  className: '',
  onCloseRequest: function onCloseRequest() {
    return null;
  }
};